import { EntityId } from "@reduxjs/toolkit";

import LoadingButton from "@mui/lab/LoadingButton";

import { usePlayMediaClipMutation } from "services/streamingApi/siteCommands.api";

import { unwrappableActionSnackbarNotificationDecorator } from "utils/unwrappableActionSnackbarNotificationDecorator";
import { MediaClipType } from "types/MediaClipType";

export interface PlayMediaClipButtonProps {
    siteId: EntityId;
    mediaClipType: MediaClipType;
    icon: React.ReactNode;
    buttonText: string;
    successMessage: string;
    failureMessage: string;
}

export function PlayMediaClipButton(props: PlayMediaClipButtonProps) {
    const [playMediaClip, { isLoading }] = usePlayMediaClipMutation();

    return (
        <LoadingButton
            variant="outlined"
            startIcon={props.icon}
            loading={isLoading}
            loadingPosition="start"
            onClick={() => {
                unwrappableActionSnackbarNotificationDecorator(
                    playMediaClip({
                        siteId: props.siteId,
                        mediaClipType: props.mediaClipType,
                    }),
                    props.successMessage,
                    props.failureMessage,
                );
            }}
        >
            {props.buttonText}
        </LoadingButton>
    );
}
